import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { IoChevronForward } from 'react-icons/io5';
import { scenarioApi } from '@/api/scenarios';
import { Breadcrumbs } from "@/components/ui/Breadcrumbs.ts";
import { Title } from "@/components/ui/Title.ts";
import { Container, Form } from './styles/AddScenarioPage.styles';

import {
  MetadataInput,
  RunButton
} from './styles/RunScenarioPage.styles';
import { styled } from 'styled-components';

const FormGroup = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const Label = styled.label`
  font-size: 14px;
  font-weight: 700;
  width: 175px;
  padding-top: 10px;
  margin-bottom: 10px;
`;

export const RunScenarioPage = () => {
  const { scenarioId } = useParams();
  const [metadata, setMetadata] = useState(`{
  "tg_username": "nik",
  "channel": "tg",
  "chat_id": "1111"
}`);


  const handleRun = async () => {
    try {
      const parsedMetadata = JSON.parse(metadata);
      await scenarioApi.runScenario({
        metadata: parsedMetadata,
        start_step_number: 0,
        scenario_id: parseInt(scenarioId || "0"),
        input_string: "",
        only_new: false,
        restart: false
      });
    } catch (error) {
      console.error('Error running scenario:', error);
    }
  };

  return (
    <Container>
      <Title>Добавить сценарий</Title>
      <Breadcrumbs>
        <Link to="/dashboard/assistants">Мои сценарии</Link>
        <IoChevronForward size={14} />
        <Link to={`/dashboard/assistants/${scenarioId}`}>Наименование ассистента</Link>
        <IoChevronForward size={14} />
        <span>Run</span>
      </Breadcrumbs>

      <Form>
        <FormGroup>
          <Label>Метаданные чата</Label>
          <MetadataInput
            value={metadata}
            onChange={(e) => setMetadata(e.target.value)}
            rows={10}
          />
        </FormGroup>

        <FormGroup>
          <div style={{ width: '175px' }}></div>
          <RunButton onClick={handleRun}>
            Run
          </RunButton>
        </FormGroup>
      </Form>
    </Container>
  );
};
